import React from 'react';
import propTypes from 'prop-types';

export const DownIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.1018 8C5.02785 8 4.45387 9.2649 5.16108 10.0731L10.6829 16.3838C11.3801 17.1806 12.6197 17.1806 13.3169 16.3838L18.8388 10.0731C19.5459 9.2649 18.972 8 17.898 8H6.1018Z"
        fill="#212121"
      />
    </svg>
  );
};

DownIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
DownIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
